import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, map, Observable, of, switchMap, timeout } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { KeplerDBUserProfile } from './kepler-db.interface';

@Injectable({ providedIn: 'root' })
export class KeplerDbService {
    private http = inject(HttpClient);
    private authService = inject(AuthService);

    constructor() {}

    getProfileData(email: string): Observable<KeplerDBUserProfile> {
        return this.http.get<KeplerDBUserProfile>(`${environment.api.kepler.db.url}/profile/${email}`);
    }

    /** @returns url to the current user's profile picture */
    get pfpLink$(): Observable<string> {
        return this.authService.claims$.pipe(
            switchMap((claims) => {
                const email = claims?.email;
                if (!email) return of('');
                return this.getProfileData(email).pipe(
                    timeout(10000),
                    map((profile) => profile?.image || ''),
                    catchError((error) => {
                        console.error('[Services][KeplerDbService] Error fetching profile picture:', error);
                        return of('');
                    }),
                );
            }),
        );
    }
}
